var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAbcLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 800 800",
    style: {
      enableBackground: "new 0 0 800 800"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(1.0226828)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391.1,170.3c-122,0-220.8,98.9-220.8,220.8c0,121.9,98.9,220.8,220.8,220.8c122,0,220.8-98.9,220.8-220.8 C611.9,269.2,513.1,170.3,391.1,170.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M520.8,330.6c-33.5,0-60.6,27.1-60.6,60.6s27.1,60.6,60.6,60.6c30.3,0,55.9-22.5,60-52.5h-34.6 c-3.4,10.8-13.5,18.6-25.4,18.6c-14.7,0-26.6-11.9-26.6-26.6c0-14.7,11.9-26.6,26.6-26.7c11.9,0,22,7.8,25.4,18.6h34.6 C576.7,353.1,551.1,330.6,520.8,330.6 M261.2,417.9c-14.7,0-26.6-11.9-26.6-26.7s11.9-26.6,26.6-26.6c14.7,0,26.6,11.9,26.6,26.6 C287.8,405.9,275.9,417.9,261.2,417.9 M321.8,450.8v-59.6c0-33.5-27.1-60.6-60.6-60.6s-60.6,27.1-60.6,60.6s27.1,60.6,60.6,60.6 c9.9,0,20.1-4.2,27.3-11.2v10.2H321.8z M390.9,364.6c14.7,0,26.6,11.9,26.6,26.7c0,14.7-11.9,26.6-26.6,26.6 c-14.7,0-26.6-11.9-26.6-26.6C364.2,376.5,376.1,364.6,390.9,364.6 M330.3,300.8v90.4c0,33.5,27.1,60.6,60.6,60.6 c33.5,0,60.6-27.1,60.6-60.6s-27.1-60.6-60.6-60.6c-9.2,0-18.8,3-26.6,8.3v-38.1H330.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbcLogo);
export default __webpack_public_path__ + "static/media/AbcLogo.d63bbfc64fc19a4231e5097253147d94.svg";
export { ForwardRef as ReactComponent };